/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProjectDiagramZOrderInfo } from './projectDiagramZOrderInfo';


/**
 * Project diagram z-order
 */
import { ValidateUtils } from 'app/shared/utils';

export class ProjectDiagramZOrder { 
    /**
     * Diagram factors
     */
    diagramFactors?: Array<ProjectDiagramZOrderInfo>;
    /**
     * Diagram links
     */
    diagramLinks?: Array<ProjectDiagramZOrderInfo>;

    constructor(item?: Partial<ProjectDiagramZOrder>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            diagramFactors: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.diagramFactors : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            diagramLinks: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.diagramLinks : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: ProjectDiagramZOrder.isValid,
        };
    }

    static isValid(obj: ProjectDiagramZOrder): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = ProjectDiagramZOrder.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.diagramFactors.isValid(item);
            result = result && validationObject.diagramLinks.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

